import script from "./WordsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WordsView.vue?vue&type=script&setup=true&lang=ts"

import "./WordsView.vue?vue&type=style&index=0&id=b358d26c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b358d26c"]])

export default __exports__